
  <div class="row align-items-center">
      <div class="col-md-12 col-sm-12 p-1">
        <img class="img-fluid padrao_img">
        <h6 class="text-center"><strong>Lorem impsum</strong></h6>
      <p class="text-center p-1 texto">Lorem Ipsum is simply dummy text of thep rinting and typesetting </p>
      </div>
  </div>